<template>
  <v-container>
    <v-card>
      <v-toolbar flat>
        <v-btn :to="{ name: 'locais_de_estoques_page' }" exact icon>
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>

        <v-toolbar-title>{{ data.nome }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click="handleClickAtualizar()" icon>
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
        <v-btn @click="handleClickRemoverLocalDeEstoque()" icon>
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-subtitle v-if="data.endereco_cliente">
        {{ data.endereco_cliente.rua }}, {{ data.endereco_cliente.numero }}
        <br />
        <div v-if="data.endereco_cliente.complemento">
          Compĺemento: {{ data.endereco_cliente.complemento }}
          <br />
        </div>
        Bairro {{ data.endereco_cliente.bairro }},
        <br />
        {{ data.endereco_cliente.cidade }} - {{ data.endereco_cliente.uf }}
        <br />
        CEP: {{ data.endereco_cliente.cep }}
      </v-card-subtitle>

      <v-tabs v-model="tab">
        <v-tab :tab-value="0">
          Estoque
        </v-tab>
        <v-tab :tab-value="1">
          Transferências
        </v-tab>
      </v-tabs>
      <v-divider></v-divider>

      <v-tabs-items v-model="tab">
        <v-tab-item :value="0">
          <v-toolbar flat dense>
            <v-btn
              @click="handleClickAdicionarProduto()"
              color="primary"
              text
              small
            >
              <v-icon>mdi-plus</v-icon> Adicionar
            </v-btn>
            <v-btn @click="handleClickTransferir()" color="primary" text small>
              <v-icon>mdi-swap-horizontal</v-icon> Transferir
            </v-btn>
          </v-toolbar>

          <v-data-table
            :headers="headers"
            :items="produtos"
            :loading="loadingProducts"
            sortBy="produto_nome"
            :mustSort="true"
          >
            <template v-slot:item.actions="{ item }">
              <v-btn
                @click="handleClickTransferirProduto(item)"
                small
                icon
                color="primary"
              >
                <v-icon>mdi-swap-horizontal</v-icon>
              </v-btn>

              <v-menu>
                <template #activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon>
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>

                <v-list>
                  <v-subheader>
                    {{ item.produto_nome }}
                  </v-subheader>
                  <v-list-item @click="handleClickAdicionarProduto(item)">
                    <v-list-item-icon>
                      <v-icon>mdi-plus</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>
                        Adicionar estoque
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item @click="handleClickRemoverProduto(item)">
                    <v-list-item-icon>
                      <v-icon>mdi-minus</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>
                        Remover estoque
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </v-data-table>
        </v-tab-item>

        <v-tab-item :value="1" eager>
          <TabelaTransferencias
            :localDeEstoqueId="data.id"
            ref="tabela_transferencias"
            @excluido="carregarProdutos()"
            @transferido="carregarProdutos()"
          />
        </v-tab-item>
      </v-tabs-items>
    </v-card>

    <LocalEstoqueAtualizarDialogo
      ref="atualizar"
      @atualizado="atualizarLocalEstoque"
    />

    <AdicionarRemoverProdutoDialogo
      ref="adicionarProdutoDialogo"
      :localEstoqueId="data.id"
      @saved="carregarProdutos()"
    />

    <AdicionarTransferenciaDialogo
      ref="transferencias"
      :produtos="produtos"
      :localEstoque="data"
      @adicionado="$refs.tabela_transferencias.carregar()"
    />

    <ConfirmationDialog ref="confirmationDialog" />
  </v-container>
</template>

<script>
import LocalEstoqueAtualizarDialogo from "@/components/locacoes/localEstoque/LocalEstoqueAtualizarDialogo.vue";
import AdicionarRemoverProdutoDialogo from "@/components/locacoes/localEstoque/AdicionarRemoverProdutoDialogo.vue";
import AdicionarTransferenciaDialogo from "@/components/locacoes/transferencias/AdicionarTransferenciaDialogo.vue";
import TabelaTransferencias from "@/components/locacoes/transferencias/TabelaTransferencias.vue";
import ConfirmationDialog from "@/components/tools/ConfirmationDialog.vue";
import locacoes from "@/services/locacoes.js";
import alerts from "@/mixins/alerts.js";

export default {
  mixins: [alerts],

  components: {
    LocalEstoqueAtualizarDialogo,
    AdicionarRemoverProdutoDialogo,
    AdicionarTransferenciaDialogo,
    ConfirmationDialog,
    TabelaTransferencias
  },

  props: {
    localEstoque: {
      type: Object
    }
  },

  data() {
    return {
      tab: 0,
      data: null,
      loadingProducts: false,
      produtos: [],
      headers: [
        {
          text: "",
          value: "actions",
          sortable: false,
          width: 120
        },
        {
          text: "Produto",
          value: "produto_nome"
        },
        {
          text: "Quantidade",
          value: "quantidade"
        }
      ]
    };
  },

  methods: {
    handleClickTransferir() {
      this.$refs.transferencias.open();
    },

    handleClickTransferirProduto(produto) {
      this.$refs.transferencias.open(produto.produto_id);
    },

    handleClickAtualizar() {
      this.$refs.atualizar.open(this.localEstoque);
    },

    atualizarLocalEstoque(localEstoque) {
      this.data = localEstoque;
    },

    handleClickAdicionarProduto(produto = null) {
      if (produto === null) {
        this.$refs.adicionarProdutoDialogo.open();
        return;
      }

      this.$refs.adicionarProdutoDialogo.open({
        produto_id: produto.produto_id
      });
    },

    handleClickRemoverLocalDeEstoque() {
      this.$refs.confirmationDialog.confirm(
        "Remover local de estoque?",
        async ({ close, startLoading, stopLoading }) => {
          startLoading();
          try {
            await locacoes.locais_de_estoque.remover(this.data.id);
            this.sendMessage("Local de estoque removido");
            this.$router.replace({
              name: "locais_de_estoques_page"
            });
            close();
          } catch (error) {
            this.error(
              "Não foi possível excluir, entre em contato com o suporte"
            );
          } finally {
            stopLoading();
          }
        },
        null,
        {
          color: "red",
          dark: true,
          description: `
            <ul>
              <li>Todos os produtos serão excluídos</li>
              <li>Todas as transferências serão excluídas</li>
              <li>Não será possível desfazer esta ação</li>
            </ul>
          `,
          confirmText: "Excluir"
        }
      );
    },

    handleClickRemoverProduto(produto = null) {
      if (produto === null) {
        this.$refs.adicionarProdutoDialogo.open(null, "remove");
        return;
      }

      this.$refs.adicionarProdutoDialogo.open(
        { produto_id: produto.produto_id },
        "remove"
      );
    },

    async carregarProdutos() {
      this.loadingProducts = true;

      try {
        this.produtos = await locacoes.locais_de_estoque.indexarProdutos(
          this.localEstoque.id
        );
      } catch (error) {
        console.error(error);
        this.error("Nâo foi possível carregar produtos");
      } finally {
        this.loadingProducts = false;
      }
    }
  },

  created() {
    this.data = this.localEstoque;
    this.carregarProdutos();
  }
};
</script>
